// src/features/alerts/alertSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchAlertConfigDetails } from "./alertThunk";
import { Edit, Refresh } from "@mui/icons-material";

const initialState = {
  selectedAlert: null,
  toggle: true,
  alertCount:[],
  data: [],
  alertData: [],
  openPopup: false,
  deletePopup:false,
  multyEditPopup : false,
  addPopup: false,
  addMultiPopup:false,
  editPopup:false,
  refresh:false,
  selectAllAlert:[],
  selectedRows:[],
  vehicleSearch:"",
  loading: false,
  error: null,
};

const alertSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    resetAlertData: (state) => {
      state.alertData = []; 
      state.error = null;
      state.loading = false;
    },
    setAlertData: (state, action) => {
      state.data = action.payload;
    },
    setSelectedAlert: (state, action) => {
      state.selectedAlert = action.payload;
    },
    setToggle: (state, action) => {
      state.toggle = action.payload;
    },
    setOpenPopup: (state, action) => {
      state.openPopup = action.payload;
    },
    setDeletePopup: (state, action) => {
      state.deletePopup = action.payload;
    },
    setMultiEditPopup: (state, action) => {
      state.multyEditPopup = action.payload;
    },
    setSelectAllAlerts: (state, action) => {
      state.selectAllAlert = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
    setVehicleSearch: (state, action) => {
      state.vehicleSearch = action.payload;
    },
    setAddPopup: (state, action) => {
      state.addPopup = action.payload;
    },
    setAddMultyPopup: (state, action) => {
      state.addMultiPopup = action.payload;
    },
    setEditPopup: (state, action) => {
      state.editPopup = action.payload;
    },
    setRefresh: (state, action) => {
      state.refresh = !state.refresh;
    },
    setAlertCount: (state, action) => {
      state.alertCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlertConfigDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAlertConfigDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.alertData = action.payload || [];
      })
      .addCase(fetchAlertConfigDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  resetAlertData,
  setAlertData,
  setToggle,
  setSelectedAlert,
  setOpenPopup,
  setDeletePopup,
  setSelectAllAlerts,
  setMultiEditPopup,
  setSelectedRows,
  setVehicleSearch,
  setAddPopup,
  setAddMultyPopup,
  setEditPopup,
  setRefresh,
  setAlertCount
} = alertSlice.actions;
export default alertSlice.reducer;
